<div class="body-top d-flex justify-content-between mb-15">
  <a [attr.href]="service.getImportExampleFileUrl()" class="left-text text-neutral-n9"
    ><span class="icon-export me-10"></span>Download example file</a
  >
  <span class="right-text text-neutral-n9">Max Rows: {{ MAX_ROWS }}</span>
</div>

<div>
  <div class="form-group">
    <input-file
      (change)="onChangeImportFile($event)"
      [accept]="accept"
      [acceptExtensions]="acceptExtensions"
      [maxSize]="1048576"
      [maxFiles]="1"></input-file>
  </div>
  <div *ngIf="items.length && !importResult" class="import-section">
    <table class="import-table w-100 table table-bordered">
      <thead>
        <tr class="text-center">
          <th colspan="3">File info</th>
        </tr>
        <tr class="text-center">
          <th>Sessions</th>
          <th>Suppliers</th>
          <th>Assignments</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class="text-center">{{ sessionsCount }}</td>
          <td class="text-center">{{ supplierCount }}</td>
          <td class="text-center">{{ assignmentsCount }}</td>
        </tr>
      </tbody>
    </table>
  </div>
  <div *ngIf="importResult" class="import-section">
    <table class="import-table w-100 table table-bordered">
      <thead>
        <tr class="text-center">
          <th colspan="3">Import results (created / in file)</th>
        </tr>
        <tr class="text-center">
          <th>Sessions</th>
          <th>Suppliers</th>
          <th>Assignments</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class="text-center">{{ importResult.sessionsCreated }} / {{ sessionsCount }}</td>
          <td class="text-center">{{ importResult.suppliersCreated }} / {{ supplierCount }}</td>
          <td class="text-center">{{ importResult.assignmentsCreated }} / {{ assignmentsCount }}</td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="info-banner mt-20" *ngIf="validationInfo" [class.info-banner--error]="validationInfo.type === 'error'">
    <div class="error-note" *ngIf="validationInfo.message">
      <span class="d-block" [innerHTML]="validationInfo.message"></span>
    </div>
  </div>

  <div class="error-section" *ngIf="errors.length">
    <table class="import-table w-100">
      <thead>
        <tr class="text-center">
          <th colspan="2">Errors</th>
        </tr>
        <tr class="text-center">
          <th>Row</th>
          <th>Error</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let err of errors">
          <td>{{ err.index + 1 }}</td>
          <td>
            <p *ngFor="let textError of err.messages">{{ textError }}</p>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="modal-footer mt-15 pt-15">
    <div class="button-holder d-flex justify-content-between">
      <button (click)="onSubmitClose()" class="btn btn-outline-dark">Cancel</button>
      <button *ngIf="!importResult" (click)="onSubmitImport()" [disabled]="!items.length || loading" class="btn btn-primary ms-15">Import</button>
    </div>
  </div>
</div>
